/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Popover,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import { makeStyles } from '@mui/styles';
import React, {
  createContext,
  useEffect,
  useRef,
  useState,
  useContext,
} from 'react';
import menu from 'assets/icons/menu.svg';
import dashboardLogo from 'assets/icons/retrexlogo.png';
import retrexlogo from 'assets/svg/retrexlogoicon.svg';
import { useTheme } from '@emotion/react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ReactComponent as Search } from 'assets/svg/headersearch.svg';
import searchIcon from 'assets/svg/searchIcon.svg';
import { useHistory, useLocation } from 'react-router-dom';
import { poppins300, poppins400, poppins500 } from 'theme/common.style';

import AccountMenu from 'component/AccountMenu/AccountMenu';

import MoreVertSharpIcon from '@mui/icons-material/MoreVertSharp';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { getApiCall, postApiCall } from 'api/apiService';
import { getMoxoAcions, getMoxoActionsByFilter } from 'api/rcpapiService';
import {
  BUYER_GETQUESTION,
  GET_SEARCH_SUGGESTIONS,
  USER_TYPE,
} from 'constant/app.config';
import { cacheClear } from 'modules/public/LoginPage/LoginPage';
import { handleNonSolicitorAction } from './Notificationlink';
import Notificationpopups from './Notificationpopups';
import useSound from 'use-sound';
import PropertyCreation from 'component/PropertyCreation/PropertyCreation';
import SearchTool from './SearchTool';
import { toast } from 'react-toastify';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { datacontextsoli } from 'modules/private/BuyerSolicitor/BuyerSolicitor';
import {
  Allicon,
  Pipelineicon,
  Owner,
  Buyer,
  Taskicon,
  Notesicon,
  Addicon,
  Addrotateicon,
  Appraisal,
  Agenticon,
  Appraisalicon,
  BellColorIcon,
  BellIcon,
  Campaign,
  Cancelicon,
  HeaderMessageIcon,
  Helpicon,
  Home,
  Homeicon,
  Messageicon,
  Phone,
  Property,
  Setting,
  SmallAddrotateicon,
  Smallplus,
  Smallsearch,
  Solicitoricon,
} from 'assets/svgfunctions/commonsvg';
let foralertcount = '';
let storeddata = '';

const useStyles = makeStyles({
  paper: {
    right: '-20.5%',
    top: '-31%',
    borderRadius: '5px',
    height: '284px',
    width: '303px',
  },
  customTextField: {
    '& input::placeholder': {
      color: '#66666 !important',
      fontSize: '14px',
      fontWeight: 400,
      fontFamily: 'poppins',
      opacity: 0.9,
    },
  },
});

const notificationcontext = createContext();
function AppHeader({
  getBuyerIndividualValue,
  sharedpage,
  setOpenlogin,
  openlogin,
  clickedmenu,
  clickedmessenger,
  message,
  setMessage,
  landing,
  progressCount,
  solicitor,
  setBinderId,
  changestab,
  setDashormes,
  dashormes,
  setNotificationCount,
  setSelectedBuyerid,
  setChangestab,
  setOpenprofile,
  openhelp,
  setOpenhelp,
  setIsOpenFileManager,
}) {
  const [ip, setIp] = useState(false);
  const token = localStorage.getItem('moxoDetail');
  const data1 = localStorage.getItem('userDetail');
  const rawDashboardCount = localStorage.getItem('dashboardCount');
  const dashboardCount =
    rawDashboardCount && rawDashboardCount !== 'undefined'
      ? JSON.parse(rawDashboardCount)
      : '';
  const context = useContext(solicitor ? datacontextsoli : datacontext);

  // If landing is true, ignore context
  const { setShowMessage, setMessagedata, realTimeLog } = landing
    ? {
        setShowMessage: () => {},
        setMessagedata: () => {},
      }
    : context || {};

  const userDetail = JSON.parse(data1);
  const dataType = userDetail?.userType;
  const usermail = userDetail?.userEmail;
  const ProgressData = Math.round(dashboardCount?.profileSurvey ?? '');
  let [responseCount, setResponseCount] = React.useState('');
  let [impdata, setImpdata] = React.useState('');
  const [taskdata, setTaskdata] = React.useState([]);
  let [alltab, setAlltab] = React.useState(false);
  let [actionitem_datas, setActionitem_datas] = React.useState('');
  let [isfetching, setIsfetching] = React.useState(false);
  const [questionBox, setQuestionBox] = useState(false);
  const [showpopup, setShowpopup] = useState([]);
  const trashdataRef = useRef([]);
  const audiofile =
    JSON.parse(localStorage.getItem('audiofiles') || '{}')?.Notification ?? '';
  // const audiofile = (() => { try { return JSON.parse(localStorage.getItem("audiofiles") || "{}")?.Notification ?? ""; } catch { return ""; } })();
  const [audioplay] = useSound(audiofile);

  useEffect(() => {
    cacheClear();
    if (!currentPage.includes('/share')) {
      Notify({
        fetchFilters: true,
        showLoader: true,
      });
    }
  }, []);

  // Notification onclick event data

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    // --- Message Handler: Contains the original action logic ---
    const messageHandler = (event) => {
      if (event.data?.type === 'NAVIGATE') {
        // **RE-INTEGRATED YOUR FULL ACTION LOGIC HERE**
        return handleNonSolicitorAction(
          event.data.payload.propertyId,
          event.data.payload.binderId,
          event.data.payload.title,
          event.data.payload.sub_title,
          history,
          primaryUserTypeValue,
          setQuestionBox,
          event.data.payload.creatorId,
          setSelectedBuyerid,
          setOpensolicitor,
          setShowMessage,
          setMessagedata
        );
      }
    };

    // 1. Set up the message listener
    navigator.serviceWorker.addEventListener('message', messageHandler);

    // --- Readiness Logic: To ensure communication on new tabs ---
    const sendReadyMessage = () => {
      const swController = navigator.serviceWorker.controller;
      if (swController) {
        swController.postMessage({
          type: 'CLIENT_READY_FOR_NOTIFICATION',
        });
      }
    };

    // 2. Wait for Service Worker control, then send the ready signal
    navigator.serviceWorker.ready.then(() => {
      sendReadyMessage();
    });

    // 3. Cleanup function: Important for React's lifecycle
    return () => {
      navigator.serviceWorker.removeEventListener('message', messageHandler);
    };
  }, []);

  useEffect(() => {
    if (!currentPage.includes('/share') && questionBox) {
      //buyer question get api to filter empty answers
      getApiCall(`${BUYER_GETQUESTION}/0`).then((res) => {
        if (res?.data?.status == 1) {
          const result = res?.data?.buyerQuestions.filter((value) => {
            if (value.questionAnswer != null) {
              return value.questionAnswer == '';
            }
          });
          localStorage.setItem('questions', JSON.stringify(result));
          if (result?.length > 0) {
            history.push('/Buyerfeedback');
          } else {
            toast.info('Survey already completed !', {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: 0,
              theme: 'light',
              style: {
                fontFamily: 'Poppins', // 👈 Inline Poppins font
              },
            });
          }
        }
      });
    }
  }, [questionBox]);

  const [alertaudio, setAlertaudio] = useState(false);

  const audiofunc = () => {
    if (!localStorage.getItem('notificationaudio') || showpopup?.length > 0) {
      audioplay();
      for (let i = 0; i < 10; i++) {
        setTimeout(() => {
          setAlertaudio((prevState) => !prevState);
        }, (i + 1) * 500); // Change state every second
      }
      setTimeout(() => {
        if (showpopup?.length > 0) {
          setOpenBelliconpops(false);
          setShowpopup([]);
        }
      }, 7000);
    }
    localStorage.setItem('notificationaudio', 'Done');
  };

  let readCount = 0;

  const history = useHistory();
  const [menubtn, setMenubtn] = useState(false);
  const [messenger, setMessenger] = useState(false);

  const path = window.location.BuyerDashboard;

  const [important, setImportant] = React.useState(false);
  const [showicon, setShowicon] = React.useState(false);
  const [showid, setShowid] = React.useState();
  const [binderid, setBinderid] = React.useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEllogout, setAnchorEllogout] = useState(null);
  const [openBellicon, setOpenBellicon] = useState(false);
  const [openBelliconpops, setOpenBelliconpops] = useState(false);
  const [searchiconsm, setSearchiconsm] = useState(false);
  const [opensolicitor, setOpensolicitor] = useState(false);
  const [trashdata, setTrashdata] = React.useState([]);

  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xl'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches1300 = useMediaQuery(theme.breakpoints.down(1300));
  const matches365 = useMediaQuery(theme.breakpoints.down(365));
  const matches79 = useMediaQuery(theme.breakpoints.between(700, 900));

  const Notify = async ({ fetchFilters = false, showLoader = false } = {}) => {
    if (showLoader) {
      setIsfetching(true);
    }
    if (fetchFilters) {
      await getMoxoActionsByFilter('important').then((res) => {
        if (res?.data?.length > 0) {
          setImpdata(res?.data);
        } else {
          setImpdata([]);
        }
      });
      await getMoxoActionsByFilter('trash').then((res) => {
        if (res?.data?.length > 0) {
          setTrashdata(res?.data);
        } else {
          setTrashdata([]);
        }
      });
      await getMoxoActionsByFilter('task').then((res) => {
        if (res?.data?.length > 0) {
          setTaskdata(res?.data);
        } else {
          setTaskdata([]);
        }
      });
    }

    await getMoxoAcions().then((resp) => {
      setResponseCount(resp?.counts);
      let wholedata = resp?.data;
      let actionitem_length = wholedata?.length;

      wholedata.sort((a, b) => {
        return (
          new Date(b.transobject.created_time) -
          new Date(a.transobject.created_time)
        ); // For descending order
      });
      setActionitem_datas(wholedata);
      setIsfetching(false);

      if (storeddata == '') {
        // If storeddata is empty, initialize it with all items
        storeddata = [...wholedata];
      } else {
        // Combine filtered lists into one dataset
        let dataset = [...wholedata];
        // Find new items that are not in storeddata
        const newItems = dataset.filter((item) => {
          // Check if the item already exists in storeddata (by id or another unique identifier)
          return !storeddata.some(
            (storedItem) =>
              storedItem.transobject?.id == item.transobject?.id &&
              storedItem.binder_id == item.binder_id
          );
        });
        // If there are new items, update showpopup state
        if (Array.isArray(newItems) && newItems.length > 0) {
          setShowpopup((prevState) => {
            if (!Array.isArray(prevState)) {
              return [...newItems]; // If prevState is not an array, just return newItems
            }
            return [...prevState, ...newItems]; // Otherwise, merge with prevState
          });
        }
        // Update storeddata with all items from dataset (this step ensures storeddata contains the latest items)
        storeddata = dataset;
      }

      if (readCount > 0) {
        if (foralertcount == '' && actionitem_length - readCount > 0) {
          audiofunc();
        }
        if (
          foralertcount != '' &&
          foralertcount != actionitem_length - readCount
        ) {
          audiofunc();
        }
        foralertcount = actionitem_length - readCount;
        if (dataType != 'Solicitor' && !currentPage.includes('/landingpage')) {
          setNotificationCount(actionitem_length - readCount);
        }
      } else {
        if (foralertcount == '' && actionitem_length > 0) {
          audiofunc();
        }
        if (foralertcount != '' && foralertcount != actionitem_length) {
          audiofunc();
        }
        foralertcount = actionitem_length - readCount;
        if (dataType != 'Solicitor' && !currentPage.includes('/landingpage')) {
          setNotificationCount(actionitem_length);
        }
      }
    });
  };

  useEffect(() => {
    if (!currentPage.includes('/share')) {
      // const intervalId = setInterval(() => {
      Notify({
        fetchFilters: false,
        showLoader: false,
      });
      // }, 10000); // 10000 milliseconds = 10 seconds

      // Cleanup function to clear the interval when component unmounts
      // return () => clearInterval(intervalId);
    }
  }, [realTimeLog]);

  useEffect(() => {
    if (showpopup?.length > 0) {
      if (!openBellicon) {
        setOpenBelliconpops(true);
        audiofunc();
      } else {
        setShowpopup([]);
      }
    }
  }, [showpopup]);

  const onclickedmenufun = () => {
    setMenubtn((prev) => {
      const newValue = !prev;
      clickedmenu(newValue);
      return newValue;
    });
  };
  const messengerclick = () => {
    // setMessenger(!messenger);
    // clickedmessenger(messenger);
    setMessenger((prevMessenger) => {
      const newMessenger = !prevMessenger;
      clickedmessenger(newMessenger);
      return newMessenger;
    });
  };
  const location = useLocation();

  const [clicked, setClicked] = useState(true);
  const handleIconClick = (event) => {
    setClicked(!clicked);
    if (anchorEl == null) {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };

  function clearlocalStorage() {
    // localStorage.clear();
  }
  const handleLogoutClick = (event) => {
    if (anchorEllogout == null) {
      setAnchorEllogout(event.currentTarget);
    } else {
      setAnchorEllogout(null);
    }
  };
  const currentPage = window.location.pathname;
  const [anchorElMenu, setAnchorElMenu] = React.useState();
  const openMenu = Boolean(anchorElMenu);
  const handleClick = (event) => {
    setAnchorElMenu(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElMenu(null);
  };
  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));
  useEffect(() => {
    if (!solicitor) {
      setMessenger(false);
      if (!currentPage.includes('/landingpage')) {
        if (typeof clickedmessenger === 'function') {
          clickedmessenger(false);
        }
      }
    }
  }, [currentPage, solicitor, setMessenger, clickedmessenger]);

  const Openmessage = async (
    propertyId,
    binderid,
    title,
    subtitle,
    creator
  ) => {
    setOpenBellicon(false);
    if (solicitor) {
      setMessage(true);
      setChangestab(true);
      setShowMessage(true);
      setMessagedata({ binderId: binderid });
    } else {
      await handleNonSolicitorAction(
        propertyId,
        binderid,
        title,
        subtitle,
        history,
        primaryUserTypeValue,
        setQuestionBox,
        creator,
        setSelectedBuyerid,
        setOpensolicitor,
        setShowMessage,
        setMessagedata
      );
    }
  };

  useEffect(() => {
    if (changestab == true) {
      setDashormes(!dashormes);
    }
  }, [changestab]);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 20,
    width: 169,
    position: 'relative',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      background: '#FAFAFA',
      border: '0.81px solid',
      borderRadius: 20,
      borderColor: '#6C2AD2',
    },
    [`& .${linearProgressClasses.bar}`]: {
      background:
        'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
      borderRadius: 2.42,
      transition: 'none',
    },
  }));
  const TextOverlay = styled(Typography)(({ theme, leftPosition }) => ({
    position: 'absolute',
    top: '50%',
    left: `${leftPosition}%`,
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    fontSize: '10px',
    fontFamily: 'Poppins',
    color: '#FFFFFF',
    fontWeight: '400px',
    alignItems: 'center',
  }));

  function LinearProgressBarWithPercentage(props) {
    const rediness = props.rediness || 0;
    const value = Number(props?.value) || 0;
    return (
      <div style={{ position: 'relative' }}>
        <BorderLinearProgress
          variant="determinate"
          // value={props?.value == 0 ? 0 : `${Math.round(Number(props?.value))}`}
          value={value}
        />
        <TextOverlay
          sx={{
            color: value < 50 ? 'black' : '#fff',
            marginLeft: '90px',
            fontSize: '12px',
            textShadow: value > 50 ? '-1px 1px 0px black' : 'none',
          }}
          variant="body2"
          color="textSecondary"
          leftPosition={'50%'}
        >
          {/* {props?.value == props?.value == 0 ? "0%" : props?.value+"%"} */}
          {value === 0 ? '0%' : `${value}%`}
        </TextOverlay>
      </div>
    );
  }

  const CircleWithInitials = ({ initial }) => (
    <Box
      borderRadius="50%"
      width="30px"
      height="30px"
      bgcolor="#AF05FF"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography
        variant="body1"
        color="#FFFFFF"
        sx={{ ...poppins500, fontSize: '18px' }}
      >
        {initial}
      </Typography>
    </Box>
  );

  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const isSmallScreen = useMediaQuery('(max-width:400px)');

  const [showPropertyCreation, setShowPropertyCreation] = useState(false);
  const [fromHeader, setFromHeader] = useState('');

  const handleDialogClose = () => {
    setShowPropertyCreation(false);
    setFromHeader('');
  };

  const renderComponent = (field) => {
    setClicked(!clicked);
    setAnchorEl(null);
    setShowPropertyCreation(true);
    setFromHeader(field);
  };

  const [showDropdown, setShowDropdown] = useState(false);
  const [jsonData, setJsonData] = useState({});
  const options = [
    'All',
    'Owner',
    'Buyer',
    'Task',
    'Notes',
    'Pipeline',
    'Property',
    'Appraisal',
    'Campaign',
    'Agent',
    'Solicitor',
  ];

  const getIcon = (tab, isSelected) => {
    const iconComponents = {
      All: <Allicon isSelected={isSelected} />,
      Pipeline: <Pipelineicon isSelected={isSelected} />,
      Owner: <Owner isSelected={isSelected} />,
      Buyer: <Buyer isSelected={isSelected} />,
      Task: <Taskicon isSelected={isSelected} />,
      Notes: <Notesicon isSelected={isSelected} />,
      Property: <Home isSelected={isSelected} />,
      Appraisal: <Appraisalicon isSelected={isSelected} />,
      Campaign: <Campaign isSelected={isSelected} />,
      Agent: <Agenticon isSelected={isSelected} />,
      Solicitor: <Solicitoricon isSelected={isSelected} />,
    };

    return iconComponents[tab] || null;
  };

  const [selectedOption, setSelectedOption] = useState('All');
  const [searchText, setSearchText] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [categoryMatchCounts, setCategoryMatchCounts] = useState({});
  const isMobile = useMediaQuery('(max-width:850px)');
  const [showResults, setShowResults] = useState(false);
  const [actiondone, setActiondone] = useState(false);
  const [showTabs, setShowTabs] = useState(true);
  const [searchCleared, setSearchCleared] = useState(false);
  // Handle Tab Selection
  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    if (option === 'All') {
      filterData(searchText, 'All');
    } else {
      filterData(searchText, option);
    }
  };

  // to close the searchtotol when clicked outside
  const searchContainerRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
        setSearchiconsm(false);
        setSearchText('');
        setShowTabs(true);
        setShowResults(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSearchChange = (event) => {
    setFilteredSuggestions([]);
    const value = event.target.value;
    setSearchText(value);

    if (value.trim() === '') {
      setFilteredSuggestions([]);
      setShowDropdown(false);
      setSelectedOption('All');
      setSearchCleared(true);
    } else {
      setSearchCleared(false);
      setShowDropdown(true);
    }
  };

  const filterData = (query, tab, dataSource = jsonData) => {
    if (!dataSource || Object.keys(dataSource).length === 0) {
      setFilteredSuggestions([]);
      setCategoryMatchCounts({});
      return;
    }

    const searchFilter = (data) =>
      data && typeof data === 'object'
        ? Object.values(data)
            .flatMap((value) =>
              value && typeof value === 'object' ? Object.values(value) : value
            )
            .join(' ')
            .toLowerCase()
            .includes(query.toLowerCase())
        : false;

    let results = {};
    const categoryCounts = {};

    if (tab === 'All') {
      Object.entries(dataSource).forEach(([category, data]) => {
        if (!Array.isArray(data) || data.length === 0) return;

        const filteredData = data.filter(searchFilter).map((item) => ({
          ...item,
          category: category.toLowerCase(),
        }));

        if (filteredData.length > 0) {
          categoryCounts[category.toLowerCase()] = filteredData.length;
          results[category.toLowerCase()] = filteredData;
        }
      });

      setCategoryMatchCounts(categoryCounts);
      setFilteredSuggestions(results);
    } else {
      const filteredResults = (
        Array.isArray(dataSource[tab.toLowerCase()])
          ? dataSource[tab.toLowerCase()]
          : []
      )
        .filter(searchFilter)
        .map((item) => ({
          ...item,
          category: tab.toLowerCase(),
        }));

      setFilteredSuggestions(filteredResults);
    }
  };

  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const requestCounter = useRef(0);

  const getSearchResult = async (data, currentRequestId) => {
    setIsSearchLoading(true);
    const inputData = { details: data };

    try {
      const res = await postApiCall(GET_SEARCH_SUGGESTIONS, inputData);

      // update if this is the latest request
      if (currentRequestId === requestCounter.current) {
        if (res?.data?.status === 1) {
          const updatedData = res.data;
          setJsonData(updatedData);
          filterData(data, selectedOption, updatedData);
        } else {
          setJsonData({});
          setFilteredSuggestions([]);
        }
      }
    } catch (error) {
      console.error('API Error:', error);
    } finally {
      if (currentRequestId === requestCounter.current) {
        setIsSearchLoading(false);
      }
    }
  };

  useEffect(() => {
    if (searchText.trim() === '') {
      setShowDropdown(false);
      setFilteredSuggestions([]);
      setJsonData({});
      return;
    }

    setShowDropdown(true);

    requestCounter.current += 1;
    const currentRequestId = requestCounter.current;

    getSearchResult(searchText, currentRequestId);
  }, [searchText, selectedOption]);

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems={'center'}
        justifyContent={'space-between'}
        style={{
          background: matchessm ? 'white' : '#FAFAFA',
          height: '85px',
          padding: '0px 10px',
        }}
      >
        {matcheslg ? (
          matches700 ? (
            <Grid item>
              <img
                alt="logo"
                src={retrexlogo}
                onClick={() => {
                  if (dataType == 'Solicitor') {
                    setDashormes(false);
                    setMessage(false);
                    setShowMessage(false);
                    setOpenprofile(false);
                    setOpenhelp(false);
                    setIsOpenFileManager(false);
                  } else if (USER_TYPE) {
                    setShowMessage(false);
                    history.push('/dashboard');
                  }
                }}
                style={{ cursor: 'pointer' }}
              />
            </Grid>
          ) : (
            <Grid item>
              <img
                alt="menu"
                src={dataType == 'Solicitor' ? dashboardLogo : menu}
                onClick={() => {
                  if (dataType == 'Solicitor') {
                    setDashormes(false);
                    setMessage(false);
                    setShowMessage(false);
                    setOpenprofile(false);
                    setOpenhelp(false);
                    setIsOpenFileManager(false);
                  } else if (USER_TYPE) {
                    onclickedmenufun();
                  }
                }}
                style={{ cursor: 'pointer' }}
              />
            </Grid>
          )
        ) : (
          <Grid item>
            <img
              alt="Logo"
              src={dashboardLogo}
              onClick={() => {
                if (dataType == 'Solicitor') {
                  setDashormes(false);
                  setMessage(false);
                  setShowMessage(false);
                  setOpenprofile(false);
                  setOpenhelp(false);
                  setIsOpenFileManager(false);
                } else if (USER_TYPE) {
                  setShowMessage(false);
                  history.push('/dashboard');
                }
              }}
              style={{ cursor: 'pointer' }}
            />
          </Grid>
        )}
        {(currentPage.includes('/market') || currentPage.includes('/share')) &&
        !currentPage.includes('/Survey') ? (
          <>
            <Grid
              item
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              gap={matches365 ? 0.7 : matches700 ? 1 : 3}
              sx={{ paddingRight: '5px' }}
            >
              {!currentPage.includes('/share') && (
                <>
                  {/* {progressCount != 100 ? */}
                  <>
                    {!matchessm && (
                      <Grid
                        onClick={() => {
                          if (ProgressData != 100) {
                            setShowMessage(false);
                            setQuestionBox(true);
                          }
                        }}
                        sx={{
                          cursor: ProgressData != 100 ? 'pointer' : 'default',
                        }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography
                            sx={{
                              color: '#717171',
                              fontFamily: 'poppins',
                              fontSize: '14px',
                              fontWeight: 500,
                              fontStyle: 'normal',
                            }}
                          >
                            Profile Progress
                          </Typography>
                          {/* <LinearProgressBarWithPercentage value={progressCount} /> */}
                          <LinearProgressBarWithPercentage
                            value={ProgressData}
                          />
                        </Box>
                      </Grid>
                    )}
                  </>
                  {/* } */}
                  {!matchesmd && (
                    <>
                      <Grid
                        item
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                      >
                        <Grid
                          sx={{
                            width: !matchesmd ? '180px' : '40px',
                            height: '33px',
                            borderRadius: '5px',
                            bgcolor: '#6C2AD2',
                            display: 'flex',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            cursor: 'pointer',
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            if (sharedpage) {
                              setOpenlogin(!openlogin);
                            } else {
                              localStorage.setItem(
                                'dialId',
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.agentDetails?.agentEmail
                              );
                              setShowMessage(true);
                              setMessagedata({ incomingcall: true });
                            }
                          }}
                        >
                          <Phone />
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: '14px',
                              color: '#FFFFFF',
                            }}
                          >
                            +61 2 7208 8880
                          </Typography>
                        </Grid>
                      </Grid>
                      {/* <Grid
                          item
                          display={'flex'}
                          justifyContent={'center'}
                          alignItems={'center'}
                        >
                          <Setting />
                        </Grid> */}
                    </>
                  )}

                  <Grid
                    item
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    <Typography
                      onClick={() => {
                        setOpenBellicon(!openBellicon);
                      }}
                      sx={{
                        height: '36px',
                        width: matchessm
                          ? '65px'
                          : `${
                              65 +
                              ((responseCount?.full_unread_count?.toString()
                                .length || 1) -
                                1) *
                                5
                            }px`,
                        background:
                          openBellicon || alertaudio
                            ? 'linear-gradient(#6C2AD2 0%, #75B8F8 100%)'
                            : '#F0F0F0',
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'space-around',
                        borderRadius: '6px',
                        cursor: 'pointer',
                      }}
                    >
                      <IconButton aria-label="search">
                        {openBellicon ? (
                          <BellColorIcon />
                        ) : (
                          <Badge
                            color="primary"
                            variant="dot"
                            invisible={responseCount?.full_unread_count == 0}
                          >
                            <BellIcon />
                          </Badge>
                        )}
                      </IconButton>
                      <Typography
                        fontWeight={400}
                        color={openBellicon ? '#f4f4f4' : '#717171'}
                        fontSize={14}
                        fontFamily={'poppins'}
                        marginRight={1}
                      >
                        {responseCount?.full_unread_count}
                      </Typography>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    <AccountMenu
                      opensolicitor={opensolicitor}
                      setOpensolicitor={setOpensolicitor}
                      setOpenprofile={setOpenprofile}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </>
        ) : searchiconsm ? (
          <Grid
            item
            sx={{
              minWidth: '60%',
              width: '70%',
              height: '100%',
              margin: '0px !important',
              paddingLeft: '0px !important',
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              component="form"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: matchessm ? '100%' : matchesmd ? '70%' : '35%',
                backgroundColor: '#F2F2F2',
                borderRadius: '30px',
                height: '49px',
              }}
            >
              <IconButton
                disabled
                sx={{ p: '10px', paddingLeft: '20px' }}
                aria-label="search"
              >
                <img alt="searchIcon" src={searchIcon} />
              </IconButton>
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,
                  '& input::placeholder': {
                    color: '#666666 !important',
                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: 'poppins',
                    opacity: 1,
                  },

                  fontSize: '14px',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                }}
                placeholder="Search here"
                inputProps={{
                  'aria-label': 'Search here',
                }}
                value={searchText}
                onChange={handleSearchChange}
              />
              <IconButton
                sx={{ p: '10px', paddingRight: '20px' }}
                aria-label="search"
                onClick={() => {
                  setSearchiconsm(false);
                  setShowDropdown(false);
                  setSearchText('');
                  setShowTabs(true);
                  setShowResults(false);
                }}
              >
                <Cancelicon />
              </IconButton>
            </Box>
          </Grid>
        ) : (
          <>
            {window.location.href.indexOf('solicitor') == -1 && (
              <>
                {dataType?.length === 1 &&
                  dataType[0].userType === 'Agent' &&
                  !matchesmd && (
                    <Grid item>
                      <Box
                        component="form"
                        sx={{
                          // p: "2px 4px",
                          display: 'flex',
                          justifyContent: matches700 ? 'left' : 'center',
                          paddingLeft: matches700 && '15px',
                          alignItems: 'center',
                          width: '400px',

                          // backgroundColor:"red",
                          // justifyContent: "center",
                        }}
                      >
                        <Box
                          ref={searchContainerRef}
                          sx={{ position: 'relative', width: '400px' }}
                        >
                          <Box
                            component="form"
                            sx={{
                              // p: "2px 4px",
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              // backgroundColor:"green",

                              width: '400px',
                              backgroundColor: '#F2F2F2',
                              borderRadius: '30px',
                              height: '49px',
                              // zIndex:999
                            }}
                          >
                            <IconButton
                              disabled
                              sx={{ p: '10px', paddingLeft: '20px' }}
                              aria-label="search"
                            >
                              <img alt="searchIcon" src={searchIcon} />
                            </IconButton>
                            <InputBase
                              sx={{
                                ml: 1,
                                flex: 1,
                                '& input::placeholder': {
                                  color: '#666666 !important',
                                  fontSize: '14px',
                                  fontWeight: 400,
                                  fontFamily: 'poppins',
                                  opacity: 1,
                                },

                                fontSize: '14px',
                                fontWeight: 400,
                                fontFamily: 'poppins',
                              }}
                              placeholder="Search here"
                              inputProps={{
                                'aria-label': 'Search here',
                              }}
                              value={searchText}
                              onChange={handleSearchChange}
                            />
                            {searchText && (
                              <IconButton
                                sx={{ p: '10px', paddingRight: '20px' }}
                                aria-label="search"
                                onClick={() => {
                                  setSearchiconsm(false);
                                  setShowDropdown(false);
                                  setSearchText('');
                                  setShowTabs(true);
                                  setShowResults(false);
                                }}
                              >
                                <Cancelicon />
                              </IconButton>
                            )}
                          </Box>

                          {((showDropdown && searchText.trim() !== '') ||
                            actiondone) && (
                            <SearchTool
                              isMobile={isMobile}
                              matches1300={matches1300}
                              showTabs={showTabs}
                              setShowTabs={setShowTabs}
                              showResults={showResults}
                              setShowResults={setShowResults}
                              selectedOption={selectedOption}
                              options={options}
                              handleOptionSelect={handleOptionSelect}
                              getIcon={getIcon}
                              filteredSuggestions={filteredSuggestions}
                              categoryMatchCounts={categoryMatchCounts}
                              searchText={searchText}
                              showDropdown={showDropdown}
                              setShowDropdown={setShowDropdown}
                              setSearchText={setSearchText}
                              isSearchLoading={isSearchLoading}
                              setActiondone={setActiondone}
                            />
                          )}
                        </Box>
                        <Typography
                          sx={{
                            marginLeft: '10px',
                            lineHeight: '10px',
                            cursor: 'pointer',
                          }}
                          onClick={handleIconClick}
                        >
                          {clicked ? <Addicon /> : <Addrotateicon />}
                        </Typography>
                      </Box>
                    </Grid>
                  )}
              </>
            )}

            <Grid
              item
              xs={4}
              sm={matches700 ? 4 : 5}
              md={4}
              lg={2}
              xl={2}
              display={'flex'}
              sx={{ alignItems: 'center' }}
              justifyContent={'right'}
              gap={isSmallScreen ? 1 : 2}
            >
              {window.location.href.indexOf('solicitor') == -1 ? (
                <>
                  {dataType[0].userType === 'Agent' && matchesmd && (
                    <>
                      <Grid
                        item
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                      >
                        {isSmallScreen ? (
                          <Smallsearch
                            onClick={() => {
                              setSearchiconsm(true);
                            }}
                          />
                        ) : (
                          <Search
                            onClick={() => {
                              setSearchiconsm(true);
                            }}
                          />
                        )}
                      </Grid>

                      <Grid
                        item
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                      >
                        <Typography
                          sx={{ lineHeight: '10px', cursor: 'pointer' }}
                          onClick={handleIconClick}
                        >
                          {isSmallScreen ? (
                            clicked ? (
                              <Smallplus />
                            ) : (
                              <SmallAddrotateicon />
                            )
                          ) : clicked ? (
                            <Addicon />
                          ) : (
                            <Addrotateicon />
                          )}
                        </Typography>
                      </Grid>
                    </>
                  )}
                </>
              ) : (
                <>
                  {!matchessm && (
                    <Grid
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: matchessm ? '-16px' : '',
                      }}
                    >
                      {/* Dashboard */}
                      <Grid item>
                        <Button
                          variant="text"
                          disabled={!dashormes && !openhelp && !message}
                          onClick={() => {
                            setDashormes(true);
                            setChangestab(false);
                            setMessage(false);
                            setShowMessage(false);
                            setOpenprofile(false);
                            setOpenhelp(false);
                          }}
                          disableRipple
                          sx={{
                            ...poppins300,
                            fontSize: '16px',
                            color:
                              dashormes && !openhelp && !message
                                ? '#bdbdbd'
                                : '#000000',
                            textTransform: 'capitalize',
                            marginRight: matchessm ? '-26px' : '',
                            backgroundColor: 'transparent !important',
                          }}
                        >
                          Dashboard
                        </Button>
                      </Grid>

                      {/* Message */}
                      <Grid item>
                        <Button
                          disableRipple
                          disabled={message && !openhelp}
                          onClick={() => {
                            setDashormes(false);
                            setChangestab(false);
                            setMessage(true);
                            setShowMessage(true);
                            setOpenprofile(false);
                            setOpenhelp(false);
                          }}
                          variant="text"
                          sx={{
                            ...poppins300,
                            fontSize: '16px',
                            color: message && !openhelp ? '#bdbdbd' : '#000000',
                            textTransform: 'capitalize',
                            alignItems: matchessm ? 'baseline' : '',
                            backgroundColor: 'transparent !important',
                          }}
                        >
                          Message
                        </Button>
                      </Grid>

                      {/* Help */}
                      <Grid item>
                        <Button
                          disableRipple
                          disabled={openhelp}
                          onClick={() => {
                            setDashormes(false);
                            setChangestab(false);
                            setMessage(false);
                            setShowMessage(false);
                            setOpenprofile(false);
                            setOpenhelp(true);
                          }}
                          variant="text"
                          sx={{
                            ...poppins300,
                            fontSize: '16px',
                            color: openhelp ? '#bdbdbd' : '#000000',
                            textTransform: 'capitalize',
                            backgroundColor: 'transparent !important',
                          }}
                        >
                          Help
                        </Button>
                      </Grid>
                    </Grid>
                  )}

                  {matchessm && (
                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                      <Grid>
                        <IconButton
                          disabled={!dashormes && !openhelp && !message}
                          onClick={() => {
                            setDashormes(true);
                            setChangestab(false);
                            setMessage(false);
                            setShowMessage(false);
                            setOpenprofile(false);
                            setOpenhelp(false);
                          }}
                        >
                          <Homeicon />
                        </IconButton>
                      </Grid>
                      <Grid>
                        <IconButton
                          disabled={message && !openhelp}
                          onClick={() => {
                            setDashormes(false);
                            setChangestab(false);
                            setMessage(true);
                            setShowMessage(true);
                            setOpenprofile(false);
                            setOpenhelp(false);
                          }}
                        >
                          <Messageicon />
                        </IconButton>
                      </Grid>
                      <Grid>
                        <IconButton
                          disabled={openhelp}
                          onClick={() => {
                            setDashormes(false);
                            setChangestab(false);
                            setMessage(false);
                            setShowMessage(false);
                            setOpenprofile(false);
                            setOpenhelp(true);
                          }}
                        >
                          <Helpicon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
              {/* message Icon  */}
              {/* Dashboard */}
              {dataType[0].userType == 'Buyer' ? (
                <Grid
                  sx={{
                    marginBottom: '11px',
                    cursor: progressCount != 100 ? 'pointer' : 'default',
                  }}
                  onClick={() => {
                    if (progressCount != 100) {
                      setShowMessage(false);
                      setQuestionBox(true);
                    }
                  }}
                >
                  {!matchessm && (
                    <Grid>
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                          sx={{
                            color: '#717171',
                            fontFamily: 'poppins',
                            fontSize: '14px',
                            fontWeight: 500,
                            fontStyle: 'normal',
                          }}
                        >
                          Profile Progress
                        </Typography>
                        <LinearProgressBarWithPercentage
                          value={
                            dashboardCount?.profileSurvey != 0
                              ? dashboardCount?.profileSurvey
                              : progressCount
                          }
                        />
                      </Box>
                    </Grid>
                  )}
                </Grid>
              ) : (
                ''
              )}
              {!currentPage.includes('/tasks') &&
                !currentPage.includes('/People') && (
                  <Grid
                    item
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    {matches &&
                      window.location.href.indexOf('solicitor') == -1 && (
                        <Typography
                          onClick={messengerclick}
                          sx={{
                            height: '36px',
                            width: '36px',
                            background: messenger
                              ? 'linear-gradient(#6C2AD2 0%, #75B8F8 100%)'
                              : '#F0F0F0',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            // padding: "5px 10px",
                          }}
                        >
                          <HeaderMessageIcon
                            color={messenger ? '#f4f4f4' : '#717171'}
                          />
                        </Typography>
                      )}
                  </Grid>
                )}
              {/* notification Icon  */}
              <Grid
                item
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Typography
                  onClick={() => {
                    setOpenBellicon(!openBellicon);
                  }}
                  sx={{
                    height: '36px',
                    width: matchessm
                      ? '65px'
                      : `${
                          65 +
                          ((responseCount?.full_unread_count?.toString()
                            .length || 1) -
                            1) *
                            5
                        }px`,
                    background:
                      openBellicon || alertaudio
                        ? 'linear-gradient(#6C2AD2 0%, #75B8F8 100%)'
                        : '#f0f0f0ff',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-around',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    // padding: "5px 10px",
                  }}
                >
                  <IconButton aria-label="search">
                    {openBellicon ? (
                      <BellColorIcon />
                    ) : (
                      <Badge
                        color="primary"
                        variant="dot"
                        invisible={responseCount?.full_unread_count == 0}
                      >
                        <BellIcon />
                        {/* <MailIcon color="action" /> */}
                      </Badge>
                    )}
                  </IconButton>
                  <Typography
                    fontWeight={400}
                    color={openBellicon ? '#f4f4f4' : '#717171'}
                    fontSize={14}
                    fontFamily={'poppins'}
                    marginRight={1}
                  >
                    {responseCount?.full_unread_count}
                  </Typography>
                </Typography>
                {/* <Typography
              component={"button"}
              sx={{
                height: "44px",
                width: "43px",
                backgroundColor: "#666666",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "6px",
                // padding: "7px 10px",
                cursor: "pointer",
              }}
              onClick={handleLogoutClick}
            >
              <Typography
                fontWeight={500}
                color="#FFFFFF"
                fontFamily="Poppins"
                fontSize="16px"
              >
                {userDetail?.userName[0].toUpperCase()}
              </Typography>
            </Typography>
            <Popover
              open={Boolean(anchorEllogout)}
              anchorEl={anchorEllogout}
              onClose={handleLogoutClick}
              anchorOrigin={{
                vertical: 50,
                horizontal: -102,
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "",
              }}
            >
              <Stack
                direction={"row"}
                sx={{
                  padding: "10px 20px",
                  backgroundColor: "#E7E6E6",
                  border: "1px solid grey",
                }}
                gap={2}
              >
                <Typography
                  fontWeight={400}
                  fontSize={18}
                  color={`linear-gradient(162.58deg, #6c2ad2 1.87%, #77cffe 98.78%)`}
                  fontFamily={"poppins"}
                  component={"div"}
                  onClick={() => {
                    clearlocalStorage();
                    history.push("/logout");
                  }}
                  sx={{ cursor: "pointer" }}
                >
                  Logout
                </Typography>
                <Logout />
              </Stack>
            </Popover> */}
              </Grid>
              <Grid
                item
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <AccountMenu
                  opensolicitor={opensolicitor}
                  setOpensolicitor={setOpensolicitor}
                  setOpenprofile={setOpenprofile}
                />
              </Grid>
            </Grid>

            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleIconClick}
              anchorOrigin={{
                vertical: 'bottom',
                // horizontal: matches79 ? -290 : 36,
                horizontal: 36,
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: '',
              }}
            >
              <Box
                container
                style={{ padding: '10px' }}
                maxWidth={matches500 ? '210px' : '303px'}
              >
                <Grid container>
                  <Grid
                    item
                    container
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '10px',
                    }}
                  >
                    <Grid container item xs={12} spacing={2}>
                      <Grid item xs={10} lg={10} md={10} xl={10}>
                        <Stack>
                          <Stack
                            direction={'row'}
                            spacing={'12px'}
                            onClick={() => {
                              renderComponent('owner');
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <Owner />
                            {/* <img alt="profile" src={profile} /> */}
                            <Typography
                              sx={{
                                fontSize: '16px',
                                fontFamily: 'Poppins',
                                fontWeight: '400',
                              }}
                            >
                              Owner
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item xs={2} lg={2} md={2} xl={2}>
                        <Avatar
                          sx={{
                            bgcolor: '#F1F1F1',
                            color: '#666666',
                            fontSize: '16px',
                            fontFamily: 'Poppins',
                            width: '24px',
                            height: '24px',
                            Padding: '0px, 10px, 0px, 10px',
                            borderRadius: '5px',
                          }}
                          variant="rounded"
                        >
                          O
                        </Avatar>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '10px',
                    }}
                  >
                    <Grid container item xs={12} spacing={2}>
                      <Grid item xs={10} lg={10} md={10} xl={10}>
                        <Stack>
                          <Stack direction={'row'} spacing={'12px'}>
                            <Buyer />
                            {/* <img alt="profile" src={profile} /> */}
                            <Typography
                              sx={{
                                fontSize: '16px',
                                fontFamily: 'Poppins',
                                fontWeight: '400',
                              }}
                            >
                              Invite Buyer
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item xs={2} lg={2} md={2} xl={2}>
                        <Avatar
                          sx={{
                            bgcolor: '#F1F1F1',
                            color: '#666666',
                            fontSize: '16px',
                            fontFamily: 'Poppins',
                            width: '24px',
                            height: '24px',
                            Padding: '0px, 10px, 0px, 10px',
                            borderRadius: '5px',
                          }}
                          variant="rounded"
                        >
                          I
                        </Avatar>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '10px',
                    }}
                  >
                    <Grid container item xs={12} spacing={2}>
                      <Grid item xs={10} lg={10} md={10} xl={10}>
                        <Stack>
                          <Stack direction={'row'} spacing={'12px'}>
                            <Property />
                            <Typography
                              sx={{
                                fontSize: '16px',
                                fontFamily: 'Poppins',
                                fontWeight: '400',
                              }}
                            >
                              Task
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item xs={2} lg={2} md={2} xl={2}>
                        <Avatar
                          sx={{
                            bgcolor: '#F1F1F1',
                            color: '#666666',
                            fontSize: '16px',
                            fontFamily: 'Poppins',
                            width: '24px',
                            height: '24px',
                            Padding: '0px, 10px, 0px, 10px',
                            borderRadius: '5px',
                          }}
                          variant="rounded"
                        >
                          T
                        </Avatar>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '10px',
                    }}
                  >
                    <Grid container item xs={12} spacing={2}>
                      <Grid item xs={10} lg={10} md={10} xl={10}>
                        <Stack>
                          <Stack
                            direction={'row'}
                            spacing={'12px'}
                            onClick={() => {
                              renderComponent('property');
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <Home />
                            {/* <img alt="paper" src={paper} /> */}
                            <Typography
                              sx={{
                                fontSize: '16px',
                                fontFamily: 'Poppins',
                                fontWeight: '400',
                              }}
                            >
                              Property
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item xs={2} lg={2} md={2} xl={2}>
                        <Avatar
                          sx={{
                            bgcolor: '#F1F1F1',
                            color: '#666666',
                            fontSize: '16px',
                            fontFamily: 'Poppins',
                            width: '24px',
                            height: '24px',
                            Padding: '0px, 10px, 0px, 10px',
                            borderRadius: '5px',
                          }}
                          variant="rounded"
                        >
                          P
                        </Avatar>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '10px',
                    }}
                  >
                    <Grid container item xs={12} spacing={2}>
                      <Grid item xs={10} lg={10} md={10} xl={10}>
                        <Stack>
                          <Stack
                            direction={'row'}
                            spacing={'12px'}
                            onClick={() => {
                              renderComponent('appraisal');
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <Appraisal />
                            {/* <img alt="notification" src={notification} /> */}
                            <Typography
                              sx={{
                                fontSize: '16px',
                                fontFamily: 'Poppins',
                                fontWeight: '400',
                              }}
                            >
                              Appraisal
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item xs={2} lg={2} md={2} xl={2}>
                        <Avatar
                          sx={{
                            bgcolor: '#F1F1F1',
                            color: '#666666',
                            fontSize: '16px',
                            fontFamily: 'Poppins',
                            width: '24px',
                            height: '24px',
                            Padding: '0px, 10px, 0px, 10px',
                            borderRadius: '5px',
                          }}
                          variant="rounded"
                        >
                          A
                        </Avatar>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '10px',
                    }}
                  >
                    <Grid container item xs={12} spacing={2}>
                      <Grid item xs={10} lg={10} md={10} xl={10}>
                        <Stack>
                          <Stack
                            direction={'row'}
                            spacing={'12px'}
                            onClick={() => {
                              renderComponent('no');
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <Campaign />
                            {/* <img alt="offers" src={offers} /> */}
                            <Typography
                              sx={{
                                fontSize: '16px',
                                fontFamily: 'Poppins',
                                fontWeight: '400',
                                lineHeight: '1.5',
                              }}
                            >
                              Campaign
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item xs={2} lg={2} md={2} xl={2}>
                        <Avatar
                          sx={{
                            bgcolor: '#F1F1F1',
                            color: '#666666',
                            fontSize: '16px',
                            fontFamily: 'Poppins',
                            width: '24px',
                            height: '24px',
                            Padding: '0px, 10px, 0px, 10px',
                            borderRadius: '5px',
                          }}
                          variant="rounded"
                        >
                          C
                        </Avatar>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Popover>
          </>
        )}
        {/* for mobile and tab view to ensure searchbar gets closed */}
        {((showDropdown && searchText.trim() !== '') || actiondone) &&
          matchesmd && (
            <SearchTool
              isMobile={isMobile}
              matches1300={matches1300}
              showTabs={showTabs}
              setShowTabs={setShowTabs}
              showResults={showResults}
              setShowResults={setShowResults}
              selectedOption={selectedOption}
              options={options}
              handleOptionSelect={handleOptionSelect}
              getIcon={getIcon}
              filteredSuggestions={filteredSuggestions}
              categoryMatchCounts={categoryMatchCounts}
              showDropdown={showDropdown}
              setShowDropdown={setShowDropdown}
              searchText={searchText}
              setSearchText={setSearchText}
              setActiondone={setActiondone}
              isSearchLoading={isSearchLoading}
            />
          )}
      </Grid>

      {(openBellicon || openBelliconpops) && (
        <notificationcontext.Provider
          value={{
            openBellicon,
            setOpenBellicon,
            openBelliconpops,
            setOpenBelliconpops,
            showpopup,
            Openmessage,
            actionitem_datas,
            showicon,
            impdata,
            setShowpopup,
            setShowid,
            setBinderid,
            setShowicon,
            showid,
            binderid,
            usermail,
            Notify,
            isfetching,
            trashdata,
            dataType,
            taskdata,
            responseCount,
          }}
        >
          <Notificationpopups />
        </notificationcontext.Provider>
      )}

      {showPropertyCreation && (
        <PropertyCreation
          open={showPropertyCreation}
          onClose={handleDialogClose}
          fromHeader={fromHeader}
          isTop={true}
        />
      )}
    </>
  );
}

AppHeader.propTypes = {};

export default AppHeader;
export { notificationcontext };
